














import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { AcgnOverdueCommitDetail, AcgnOverdueAuditDetail } from './components';
import { Tabs, TabPane } from 'element-ui';

@Component({
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    AcgnOverdueCommitDetail,
    AcgnOverdueAuditDetail
  }
})

/**
 * 逾期明细
 */
export default class AcgnStatisticOverdueDetail extends Vue {

  @Prop({ default: true }) public isShowAudit: string; // 是否显示审批
  @Prop({ default: null }) public comicId: number | null; // 项目id
  @Prop({ default: null }) public userId: number | null; // 员工id

  // 1：创作方统计，2：管理方统计
  @Prop({ default: 1 }) public type: number; // 用于区分请求数据接口

  private activeName: string = 'one';

  // 1：提交、2：审核
  private tabs: any = {
    1: 'one',
    2: 'two'
  };

  private created() {
    const { type } = this.$route.params;
    this.activeName = this.tabs[type];
  }
}
